<template lang="pug">
  .datepicker(@focusout="focus = false" @focusin.capture="focus = true")
    input.input(
      :class="inputClass"
      ref="inp"
      v-model="internalValue"
      @focusout="processDateInput"
      @focusin="focus = true"
      @click="focus = true"
      :placeholder="inputPlaceholder"
      :id="inputId"
      autocomplete="off")
    dp.dp(inline
          tabindex="1"
          :value="selectedDate"
          v-show="focus"
          :disabled-dates="disabledDates"
          @selected="datePicked")
</template>

<script>
import dp from 'vuejs-datepicker'
import { format, parse, isAfter, isValid } from 'date-fns/esm'

export default {
  name: 'Datepicker',
  props: {
    inputClass: {
      type: [String, Object],
      default: '',
    },
    inputPlaceholder: {
      type: String,
      default: '',
    },
    inputId: {
      type: String,
      default: () => Math.floor(Math.random() * 100000).toString(),
    },
    value: {
      type: String,
      default: '',
    },
    disabledDates: {
      type: [Object],
      default: () => {
        return { from: new Date() }
      },
    },
  },
  data: function() {
    return {
      selectedDate: '',
      internalValue: this.value,
      focus: false,
      blurEventId: null,
      disabledFrom: new Date(),
    }
  },
  methods: {
    datePicked(value) {
      let dt = format(value, 'MM/dd/yyyy')
      this.focus = false
      this.$emit('input', dt)
      this.internalValue = dt
    },
    resetValue() {
      this.$emit('input', this.value)
      this.internalValue = this.value
    },
    processDateInput() {
      // If there is a value and it doesn't match the basic MM/DD/YYYY regex, then rest it.
      if (
        this.internalValue.length > 0 &&
        !this.internalValue.match(/\d{2}\/\d{2}\/\d{4}/)
      ) {
        this.resetValue()
        return
      }

      let dt = parse(this.internalValue, 'MM/dd/yyyy', new Date())
      // If the field has a value and it's not a valid date, then reset it..
      if (this.internalValue.length > 0 && !dt.getTime()) {
        this.resetValue()
        return
      }

      // Set the new value
      this.$emit('input', this.internalValue)
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (this.internalValue !== newVal) {
        this.internalValue = newVal
      }
    },
    internalValue(newVal, oldVal) {
      // If the old value is one digit long, and the new value is two digits, then insert a '/ at the end.
      // E.g., "1" => "12" => "12/"
      if (oldVal.length === 1 && newVal.length === 2) {
        this.$nextTick(() => (this.internalValue = this.internalValue + '/'))
      }
      // If the old value is 4 digits and the new value is 5 digits, insert a '/' at the end.
      // E.g., "01/0" => "01/01" => "01/01/"
      if (oldVal.length === 4 && newVal.length === 5) {
        this.$nextTick(() => (this.internalValue = this.internalValue + '/'))
      }
    },
  },
  components: {
    dp,
  },
}
</script>

<style lang="scss" scoped>
.dp {
  position: absolute;
  z-index: 900;
}

.input {
  width: 100%;
}

.dp:focus {
  outline: none;
}
</style>
